'use client';

import { FC, ReactNode } from 'react';

import '@telialt/utils/src/polyfills/string-replace-all';

import { SessionProlongationModal } from '../SessionProlongationModal/SessionProlongationModal';
import { useOctocomSession } from '../SessionProlongationModal/useOctocomSession';

type Props = {
    hasSessionProlongation?: boolean;
    children: ReactNode;
};

/**
 * Any generic client side component or hook should go into this component
 */
export const InitClientComponentData: FC<Props> = ({ hasSessionProlongation = true, children }) => {
    useOctocomSession();

    return (
        <>
            {children}
            {hasSessionProlongation && <SessionProlongationModal />}
        </>
    );
};
